module.exports = __webpack_public_path__ + "img/racecourse-fairview-poly-1800.7c070013.svg";